import React from 'react';
import { Dispatch } from 'redux';
import api from '../services/api';
//import { handleError } from './dashboard';
import Dot from '../components/UI/Dot/Dot';
import { handleError } from './dashboard';
export class NoWalkActionTypes {
  public static readonly GET_SEGMENTS = 'getSegments';
  public static readonly GET_PERIOD = 'getPeriod';
  public static readonly SET_SEGMENT = 'setSegments';
  public static readonly SET_PERIOD = 'setPeriod';
  public static readonly FETCH_ALL = 'fetchAll';
  public static readonly SET_TAB = 'setTab';
  public static readonly SET_SORT = 'setSort';
  public static readonly SET_SORT_TYPE = 'setSortType';
}

let mockedSegments = [
  { id: 'All', name: 'All' },
  {
    id: 'A1',
    name: (
      <div className="segmentDot">
        <Dot score={3}></Dot> A1
      </div>
    ),
  },
  {
    id: 'A2',
    name: (
      <div className="segmentDot">
        <Dot score={2}></Dot> A2
      </div>
    ),
  },
  {
    id: 'B1',
    name: (
      <div className="segmentDot">
        <Dot score={1}></Dot> B1
      </div>
    ),
  },
  {
    id: 'B2',
    name: (
      <div className="segmentDot">
        <Dot score={0}></Dot> B2
      </div>
    ),
  },
];

let mockedPeriods = [
  { id: 0, name: 'Next 3 months' },
  { id: 1, name: 'Next 6 months' },
  { id: 2, name: 'Next 12 months' },
];

export const fetchAll = (data: any) => (dispatch: Dispatch) => {
  api
    .getNoWalkScores(data)
    .then((res) => {
      dispatch({
        type: NoWalkActionTypes.FETCH_ALL,
        payload: {
          segments: mockedSegments,
          periods: mockedPeriods,
          noWalkData: res.data,
        },
        meta: {
          track: true,
        },
      });
    })
    .catch((err) => handleError(err, dispatch));
};

export const getSegments = () => (dispatch: Dispatch) => {
  dispatch({
    type: NoWalkActionTypes.GET_SEGMENTS,
    payload: mockedSegments,
    meta: {
      track: true,
    },
  });
};
export const getPeriods = () => (dispatch: Dispatch) => {
  dispatch({
    type: NoWalkActionTypes.GET_SEGMENTS,
    payload: mockedPeriods,
    meta: {
      track: true,
    },
  });
};

export const setSegment = (segment: any) => (dispatch: Dispatch) => {
  dispatch({
    type: NoWalkActionTypes.SET_SEGMENT,
    payload: segment,
    meta: {
      track: true,
    },
  });
};

export const setTab = (segment: any) => (dispatch: Dispatch) => {
  dispatch({
    type: NoWalkActionTypes.SET_TAB,
    payload: segment,
    meta: {
      track: true,
    },
  });
};

export const setSort =
  (sort: any, sortOptionals: any) => (dispatch: Dispatch) => {
    dispatch({
      type: NoWalkActionTypes.SET_SORT,
      payload: { id: sort, name: sortOptionals[sort].name },
      meta: {
        track: true,
      },
    });
  };

export const setSortType =
  (sortType: any, sortTypeOptionals: any) => (dispatch: Dispatch) => {
    dispatch({
      type: NoWalkActionTypes.SET_SORT_TYPE,
      payload: { id: sortType, name: sortTypeOptionals[sortType].name },
      meta: {
        track: true,
      },
    });
  };

export const setPeriod = (period: any) => (dispatch: Dispatch) => {
  dispatch({
    type: NoWalkActionTypes.SET_PERIOD,
    payload: period,
    meta: {
      track: true,
    },
  });
};

/*
export const getReport = async (id: number) => {
  let result = await api.getReport(id);
  return result.data;
};
*/
